import { CommonModule } from '@angular/common';
import { Component, computed, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { FileSystemService } from './services/file-system.service';
// import { UserComponent } from './components/user/user.component';
import { ToastModule } from 'primeng/toast';
import { DrawerComponent } from './components/drawer/drawer.component';
import { PrimeMenuComponent } from './components/prime-menu/prime-menu.component';
import { WorkflowService, WorkflowType } from './services/workflow.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UsdmDrawerComponent } from './components/usdm-components/usdm-drawer/usdm-drawer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    // UserComponent,
    PrimeMenuComponent,
    ToastModule,
    DrawerComponent,
    UsdmDrawerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnDestroy {
  private routerSubscription: Subscription | null = null;
  page: string = '';

  constructor(
    private fs: FileSystemService,
    private router: Router,
    private wf: WorkflowService
  ) {
    this.wf.currentWorkFlow$.subscribe(wf => {
      this.workFlow = wf;
      // console.log('AppComponent detected workflow change:', this.workFlow);
    });
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.page = event.url.split('/')[1];
      console.log('AppComponent detected navigation change:', this.page);
    });
  }

  title = 'angular';
  component: string = '';
  // node: Node = new Node('/workspace', true, []);
  visibleFilePath = computed(() => this.fs.visibleNode().path);
  workFlow: WorkflowType | null = null;

  navigateToHome() {
    this.router.navigate(['/']);
  }

  isHomePage(): boolean {
    return this.router.url === '/';
  }

  hasOsbServerUrl(): boolean {
    return (
      this.workFlow?.type === 'usdm' &&
      this.workFlow?.data &&
      'osbServerUrl' in this.workFlow.data &&
      !!this.workFlow.data.osbServerUrl
    );
  }

  getOsbServerUrl(): string | null {
    if (this.workFlow?.data && 'osbServerUrl' in this.workFlow.data) {
      return this.workFlow.data.osbServerUrl?.replace(/\/api$/, '') || null;
    }
    return null;
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
